module.exports = __webpack_public_path__ + "static/media/back-cloud.9bac72a5.png";